import type { SargassoChangeDetail } from "./bridge";
import { SargassoCanvasElement } from "./sargasso-canvas";
import { SargassoControlsElement, type SargassoControlsToggleDetail } from "./sargasso-controls";

export type {
  ContourOptions,
  CursorOptions,
  ProbeResult,
  SargassoController,
  SargassoOptions,
  SpectrumOptions,
  WaveParams,
  WavePreset,
} from "@sargasso/core";
export {
  DEFAULT_CONTOUR,
  DEFAULT_PRESET,
  DEFAULT_WAVES,
  generateWaveSpectrum,
  WAVE_PRESET_NAMES,
  WAVE_PRESETS,
} from "@sargasso/core";
export type { ResolvedCanvasOptions, SargassoChangeDetail } from "./bridge";
export {
  attributeToOption,
  makeEvent,
  OBSERVED_CANVAS_ATTRIBUTES,
  parseJsonAttr,
  parseNumberAttr,
  SARGASSO_CHANGE_EVENT,
} from "./bridge";
export { SargassoCanvasElement } from "./sargasso-canvas";
export type { SargassoControlsToggleDetail } from "./sargasso-controls";
export {
  SARGASSO_CONTROLS_TOGGLE_EVENT,
  SargassoControlsElement,
} from "./sargasso-controls";

export interface DefineOptions {
  /** Tag name for the canvas element. Defaults to `sargasso-canvas`. */
  canvas?: string;
  /** Tag name for the controls element. Defaults to `sargasso-controls`. */
  controls?: string;
}

/** Register the Sargasso custom elements. Safe to call more than once. */
export function defineSargassoElements(options: DefineOptions = {}): void {
  if (typeof customElements === "undefined") return;
  const canvasTag = options.canvas ?? "sargasso-canvas";
  const controlsTag = options.controls ?? "sargasso-controls";
  if (!customElements.get(canvasTag)) customElements.define(canvasTag, SargassoCanvasElement);
  if (!customElements.get(controlsTag)) {
    customElements.define(controlsTag, SargassoControlsElement);
  }
}

// Auto-register on import so the package works as a drop-in <script> or bare
// side-effect import.
defineSargassoElements();

declare global {
  interface HTMLElementTagNameMap {
    "sargasso-canvas": SargassoCanvasElement;
    "sargasso-controls": SargassoControlsElement;
  }
  interface GlobalEventHandlersEventMap {
    "sargasso-change": CustomEvent<SargassoChangeDetail>;
    "sargasso-controls-toggle": CustomEvent<SargassoControlsToggleDetail>;
  }
}
